import Data from "./../../Configs/JSON/PlanBenefits.json"
import "./PlanBenefits.less"
import DOMPurify from "dompurify"
const PlanBenefits = () => {


    const data = Data.data
    return (
        <div className='PlanBenefitsRoot'><div className='PlanBenefitsmain'>
            <h2 className='PlanBenefitsHead'>What are the Benefits of using an Online Pension Calculator?</h2>
            <div className='PlanBenefitsContainer'>
                <div className='PlanBenefitsImg'><img src='assets/PlanBenefits/PlanBenefits.svg' alt="PlanBenefits.svg" /></div>
                <div className='PlanBenefitsData'>
                    {data.map((value, index) =>
                        <div  dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(value.content) }} key={index}></div>
                    )}</div>
            </div></div>
        </div>
    )
}

export default PlanBenefits